
export function getFirstNode(data: any, field: string) {
    return data.data[field].edges[0].node
}

/**
 * Queryfy.
 *
 * Prep javascript objects for interpolation within graphql queries.
 *
 * @param {mixed} obj
 * @return template string.
 */
export const queryfy = (obj: {[key: string]: any}): string => {
    // Make sure we don't alter integers.
    if (typeof obj === "number") {
        return obj
    }

    // Stringify everything other than objects.
    if (typeof obj !== "object") {
        return JSON.stringify(obj)
    }
    if (Array.isArray(obj)) {
        return "[" + obj.map(queryfy).join(",") + "]"
    }

    // Iterate through object keys to convert into a string
    // to be interpolated into the query.
    const props = Object.keys(obj).map(key =>
        `${key}:${queryfy(obj[key])}`
    ).join(",")

    return `{${props}}`
}
